import React, { Component, ChangeEvent } from 'react';
import { Business } from '../../../api/models/BusinessData';
import { TextField, Button, Grid, Typography, Paper, CircularProgress, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { AbnLookupResult } from '../../../api/models/AbnLookupResult';
import Zoom from '@material-ui/core/Zoom';
import { WrongABNFormatText, validateABN } from '../../Common';

type Props = {
    abnLookup: (abn: string) => void,
    update: (b: Business) => void,
    abnLookupResult: AbnLookupResult,
    isAbnLookupBusy: boolean
}

type State = {
    business: Business,
    abnFormatError: boolean
}

class BusinessInformationForm extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            business: {
                abn: "",
                acn: "",
                chosenBusinessName: "",
            },
            abnFormatError: false
            
        }
    }

    isCompanyActive(abnLookupResult: AbnLookupResult){
        if(abnLookupResult)
            if(abnLookupResult.abnStatus && abnLookupResult.abnStatus.toLowerCase() === "active")
                return true
        
        return false
    }


    componentWillReceiveProps(nextProps: any ) {
        if(nextProps.abnLookupResult)
            if(nextProps.abnLookupResult.businessName.length === 1)
                this.setState({ business: { ...this.state.business, chosenBusinessName: nextProps.abnLookupResult.businessName[0] }})
            else if (nextProps.abnLookupResult.businessName.length === 0)
                this.setState({ business: { ...this.state.business, chosenBusinessName: nextProps.abnLookupResult.entityName }})
    }

    componentDidMount() {
        if (this.props.abnLookupResult){
            this.setState({ business: { ...this.state.business, abn: this.props.abnLookupResult.abn }})
            this.props.abnLookup(this.props.abnLookupResult.abn)}
    }

    render() {
        return (
            <div>
                <Grid container alignItems="center" alignContent="center" style={{ textAlign: 'center', padding: "15px" }}>
                    <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                        <TextField
                            onChange={(e) => {
                                let isValid = validateABN(e.target.value.replace(/ /g, ''))
                                this.setState({ business: { ...this.state.business, abn: e.target.value }, abnFormatError: !isValid },
                                    () => {
                                        if (isValid)
                                            this.props.abnLookup(this.state.business.abn.replace(/ /g, ''))
                                    })

                            }}
                            value={this.state.business.abn}
                            label="ABN"
                            margin="normal"
                            variant="outlined"
                            disabled={this.props.isAbnLookupBusy}
                            style={{ marginTop: '8px' }}
                            helperText={this.state.abnFormatError ? WrongABNFormatText : ''}
                            error={this.state.abnFormatError}
                        ></TextField>

                    </Grid>

                    <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                        {this.props.isAbnLookupBusy &&
                            <CircularProgress size={20}></CircularProgress>
                        }
                    </Grid>

                    {
                        <Zoom in={this.props.abnLookupResult && !this.props.isAbnLookupBusy} >
                            <Grid item xs={12}>
                                {this.props.abnLookupResult &&
                                    <Paper style={{ padding: '20px', borderLeft: this.props.abnLookupResult ? (this.isCompanyActive(this.props.abnLookupResult) ? "6px solid green" : "6px solid red") : 'none' }}>
                                        {this.props.abnLookupResult.message ?
                                            <Typography variant="h2">{this.props.abnLookupResult.message}</Typography>
                                            :
                                            <div>
                                                <Typography variant="h2">Your business details:</Typography>
                                                <Typography variant="h3">{this.props.abnLookupResult.entityName}</Typography>
                                                {/* <Typography variant="h3">{this.props.abnLookupResult.businessName}</Typography> */}
                                                <Typography variant="h4">{this.props.abnLookupResult.entityTypeName}</Typography>
                                                <Typography variant="h4">{this.props.abnLookupResult.addressState}, {this.props.abnLookupResult.addressPostcode}</Typography>
                                                
                                                {!this.isCompanyActive(this.props.abnLookupResult) &&
                                                    <Typography style={{color:'red'}} variant="h3">Your company is not active, thus it can't be registered in Quote My Order application.</Typography>
                                                }

                                                { this.props.abnLookupResult.businessName.length > 1 && (
                                                    <div>
                                                        <Typography style={{color:'green'}} variant="h3">Please select your business name.</Typography>
                                                        <FormControl component="fieldset">
                                                            <RadioGroup aria-label="business name" name="customized-radios" onChange={(event: ChangeEvent<{}>, value: string) => this.setState({ business: { ...this.state.business, chosenBusinessName: value} })}>
                                                                {this.props.abnLookupResult.businessName.map((element: string) => {
                                                                    return <FormControlLabel id={element} value={element} key={element} control={<Radio />} label={element}/>;
                                                                    })
                                                                }
                                                            </RadioGroup>      
                                                        </FormControl>
                                                    </div>
                                                    )} 

                                                    {this.props.abnLookupResult.businessName.length === 1 && (
                                                        <div>
                                                            <Typography style={{color:'green'}} variant="h3">Your business name:</Typography>
                                                            <Typography variant="h3">{this.props.abnLookupResult.businessName[0]}</Typography>
                                                        </div>
                                                    )}
                                                
                                            
                                            </div>
                                        }
                                    </Paper>

                                }
                            </Grid>
                        </Zoom>


                    }

                    <Grid item sm={3} md={4}></Grid>
                    <Grid item xs={12} sm={6} md={4} style={{ paddingTop: '15px' }}>
                        <Button variant="contained" color="primary" 
                            disabled={
                                this.state.abnFormatError || 
                                this.state.business.abn === "" || 
                                this.props.abnLookupResult===null || 
                                (this.props.abnLookupResult !== null && this.props.abnLookupResult.message !== "") ||
                                !this.isCompanyActive(this.props.abnLookupResult) ||
                                (this.state.business.chosenBusinessName === "")
                                } 
                            onClick={() => { this.props.update(this.state.business) }}>Next</Button>
                    </Grid>
                    <Grid item sm={3} md={4}></Grid>
                </Grid>
            </div>
        );
    }
}

export default BusinessInformationForm;